export { DMS_MODULE } from '../constants';
export const NAME = 'RealTimeInventory';
export const API_NAME = 'RealTimeInventory';
export const EXPORT_FILE_NAME = 'RealTimeInventory.xlsx';
export const CRUMB_LABEL_KEY = 'RealTimeInventory';


export type SestavaButton = { labelKey: string, routeName: string, api: string, permission: number };
